/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/~__root'
import { Route as RaidsRouteRouteImport } from './routes/~raids/~route'
import { Route as IndexRouteImport } from './routes/~index'
import { Route as RaidsCreateRouteRouteImport } from './routes/~raids_/~create/~route'
import { Route as RaidsRaidIdRouteRouteImport } from './routes/~raids_/~$raidId/~route'
import { Route as DevRadiogroupRouteRouteImport } from './routes/~dev_/~radiogroup/~route'
import { Route as DevListRouteRouteImport } from './routes/~dev_/~list/~route'
import { Route as RaidsRaidIdEditRouteRouteImport } from './routes/~raids_/~$raidId/~edit/~route'
import { Route as RaidsRaidIdIndexRouteRouteImport } from './routes/~raids_/~$raidId/~index/~route'

const RedirectRouteLazyRouteImport = createFileRoute('/redirect')()
const DevApiRouteLazyRouteImport = createFileRoute('/dev_/api')()

const RedirectRouteLazyRoute = RedirectRouteLazyRouteImport.update({
  id: '/redirect',
  path: '/redirect',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/~redirect/~route.lazy').then((d) => d.Route),
)
const RaidsRouteRoute = RaidsRouteRouteImport.update({
  id: '/raids',
  path: '/raids',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevApiRouteLazyRoute = DevApiRouteLazyRouteImport.update({
  id: '/dev_/api',
  path: '/dev/api',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/~dev_/~api/~route.lazy').then((d) => d.Route),
)
const RaidsCreateRouteRoute = RaidsCreateRouteRouteImport.update({
  id: '/raids_/create',
  path: '/raids/create',
  getParentRoute: () => rootRouteImport,
} as any)
const RaidsRaidIdRouteRoute = RaidsRaidIdRouteRouteImport.update({
  id: '/raids_/$raidId',
  path: '/raids/$raidId',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRadiogroupRouteRoute = DevRadiogroupRouteRouteImport.update({
  id: '/dev_/radiogroup',
  path: '/dev/radiogroup',
  getParentRoute: () => rootRouteImport,
} as any)
const DevListRouteRoute = DevListRouteRouteImport.update({
  id: '/dev_/list',
  path: '/dev/list',
  getParentRoute: () => rootRouteImport,
} as any)
const RaidsRaidIdEditRouteRoute = RaidsRaidIdEditRouteRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => RaidsRaidIdRouteRoute,
} as any)
const RaidsRaidIdIndexRouteRoute = RaidsRaidIdIndexRouteRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RaidsRaidIdRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/raids': typeof RaidsRouteRoute
  '/redirect': typeof RedirectRouteLazyRoute
  '/dev/list': typeof DevListRouteRoute
  '/dev/radiogroup': typeof DevRadiogroupRouteRoute
  '/raids/$raidId': typeof RaidsRaidIdRouteRouteWithChildren
  '/raids/create': typeof RaidsCreateRouteRoute
  '/dev/api': typeof DevApiRouteLazyRoute
  '/raids/$raidId/': typeof RaidsRaidIdIndexRouteRoute
  '/raids/$raidId/edit': typeof RaidsRaidIdEditRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/raids': typeof RaidsRouteRoute
  '/redirect': typeof RedirectRouteLazyRoute
  '/dev/list': typeof DevListRouteRoute
  '/dev/radiogroup': typeof DevRadiogroupRouteRoute
  '/raids/create': typeof RaidsCreateRouteRoute
  '/dev/api': typeof DevApiRouteLazyRoute
  '/raids/$raidId': typeof RaidsRaidIdIndexRouteRoute
  '/raids/$raidId/edit': typeof RaidsRaidIdEditRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/raids': typeof RaidsRouteRoute
  '/redirect': typeof RedirectRouteLazyRoute
  '/dev_/list': typeof DevListRouteRoute
  '/dev_/radiogroup': typeof DevRadiogroupRouteRoute
  '/raids_/$raidId': typeof RaidsRaidIdRouteRouteWithChildren
  '/raids_/create': typeof RaidsCreateRouteRoute
  '/dev_/api': typeof DevApiRouteLazyRoute
  '/raids_/$raidId/': typeof RaidsRaidIdIndexRouteRoute
  '/raids_/$raidId/edit': typeof RaidsRaidIdEditRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/raids'
    | '/redirect'
    | '/dev/list'
    | '/dev/radiogroup'
    | '/raids/$raidId'
    | '/raids/create'
    | '/dev/api'
    | '/raids/$raidId/'
    | '/raids/$raidId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/raids'
    | '/redirect'
    | '/dev/list'
    | '/dev/radiogroup'
    | '/raids/create'
    | '/dev/api'
    | '/raids/$raidId'
    | '/raids/$raidId/edit'
  id:
    | '__root__'
    | '/'
    | '/raids'
    | '/redirect'
    | '/dev_/list'
    | '/dev_/radiogroup'
    | '/raids_/$raidId'
    | '/raids_/create'
    | '/dev_/api'
    | '/raids_/$raidId/'
    | '/raids_/$raidId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  RaidsRouteRoute: typeof RaidsRouteRoute
  RedirectRouteLazyRoute: typeof RedirectRouteLazyRoute
  DevListRouteRoute: typeof DevListRouteRoute
  DevRadiogroupRouteRoute: typeof DevRadiogroupRouteRoute
  RaidsRaidIdRouteRoute: typeof RaidsRaidIdRouteRouteWithChildren
  RaidsCreateRouteRoute: typeof RaidsCreateRouteRoute
  DevApiRouteLazyRoute: typeof DevApiRouteLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/redirect': {
      id: '/redirect'
      path: '/redirect'
      fullPath: '/redirect'
      preLoaderRoute: typeof RedirectRouteLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raids': {
      id: '/raids'
      path: '/raids'
      fullPath: '/raids'
      preLoaderRoute: typeof RaidsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev_/api': {
      id: '/dev_/api'
      path: '/dev/api'
      fullPath: '/dev/api'
      preLoaderRoute: typeof DevApiRouteLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raids_/create': {
      id: '/raids_/create'
      path: '/raids/create'
      fullPath: '/raids/create'
      preLoaderRoute: typeof RaidsCreateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raids_/$raidId': {
      id: '/raids_/$raidId'
      path: '/raids/$raidId'
      fullPath: '/raids/$raidId'
      preLoaderRoute: typeof RaidsRaidIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev_/radiogroup': {
      id: '/dev_/radiogroup'
      path: '/dev/radiogroup'
      fullPath: '/dev/radiogroup'
      preLoaderRoute: typeof DevRadiogroupRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev_/list': {
      id: '/dev_/list'
      path: '/dev/list'
      fullPath: '/dev/list'
      preLoaderRoute: typeof DevListRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raids_/$raidId/edit': {
      id: '/raids_/$raidId/edit'
      path: '/edit'
      fullPath: '/raids/$raidId/edit'
      preLoaderRoute: typeof RaidsRaidIdEditRouteRouteImport
      parentRoute: typeof RaidsRaidIdRouteRoute
    }
    '/raids_/$raidId/': {
      id: '/raids_/$raidId/'
      path: '/'
      fullPath: '/raids/$raidId/'
      preLoaderRoute: typeof RaidsRaidIdIndexRouteRouteImport
      parentRoute: typeof RaidsRaidIdRouteRoute
    }
  }
}

interface RaidsRaidIdRouteRouteChildren {
  RaidsRaidIdIndexRouteRoute: typeof RaidsRaidIdIndexRouteRoute
  RaidsRaidIdEditRouteRoute: typeof RaidsRaidIdEditRouteRoute
}

const RaidsRaidIdRouteRouteChildren: RaidsRaidIdRouteRouteChildren = {
  RaidsRaidIdIndexRouteRoute: RaidsRaidIdIndexRouteRoute,
  RaidsRaidIdEditRouteRoute: RaidsRaidIdEditRouteRoute,
}

const RaidsRaidIdRouteRouteWithChildren =
  RaidsRaidIdRouteRoute._addFileChildren(RaidsRaidIdRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  RaidsRouteRoute: RaidsRouteRoute,
  RedirectRouteLazyRoute: RedirectRouteLazyRoute,
  DevListRouteRoute: DevListRouteRoute,
  DevRadiogroupRouteRoute: DevRadiogroupRouteRoute,
  RaidsRaidIdRouteRoute: RaidsRaidIdRouteRouteWithChildren,
  RaidsCreateRouteRoute: RaidsCreateRouteRoute,
  DevApiRouteLazyRoute: DevApiRouteLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
